module.exports = __webpack_public_path__ + "img/horizontal_6_2_pp2_7042.b510c064.png";